import React from 'react';
import PropTypes from 'prop-types';

class OnClickOutside extends React.PureComponent {
  constructor(props) {
    super(props);

    this.wrapperRef = React.createRef();
    this.onClickOutside = this.onClickOutside.bind(this);
  }

  componentDidMount() {
    window.addEventListener('mousedown', this.onClickOutside, true);
  }

  componentWillUnmount() {
    window.removeEventListener('mousedown', this.onClickOutside, true);
  }

  onClickOutside(e) {
    const { current } = this.wrapperRef;
    const { onClickOutside, ignoreSelectors } = this.props;
    const clickedInsideIgnored = ignoreSelectors.some(selector =>
      e.target.closest(selector)
    );

    if (current && !current.contains(e.target) && !clickedInsideIgnored) {
      onClickOutside(e);
    }
  }

  render() {
    const { children, className } = this.props;

    return (
      <div ref={this.wrapperRef} className={className}>
        {children}
      </div>
    );
  }
}

OnClickOutside.defaultProps = {
  className: '',
  ignoreSelectors: [],
};

OnClickOutside.propTypes = {
  className: PropTypes.string,
  ignoreSelectors: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node.isRequired,
  onClickOutside: PropTypes.func.isRequired,
};

export default OnClickOutside;
